import { createAction } from "redux-actions";
import { moduleSlug } from "modules/Scheduler/constants";

export const clearInitialScrapeTasksStatistic = createAction(`${moduleSlug}/CLEAR_INITIAL_SCRAPE_TASKS_STATISTIC`);

export const getInitialScrapeTasksStatistic = createAction(`${moduleSlug}/GET_INITIAL_SCRAPE_TASKS_STATISTIC`);
export const getInitialScrapeTasksStatisticSuccess = createAction(`${moduleSlug}/GET_INITIAL_SCRAPE_TASKS_STATISTIC/SUCCESS`);
export const getInitialScrapeTasksStatisticError = createAction(`${moduleSlug}/GET_INITIAL_SCRAPE_TASKS_STATISTIC/ERROR`);

export const changeTimePeriodReschedule = createAction(`${moduleSlug}/CHANGE_TIME_PERIOD_RESCHEDULE`);
